import { useRef, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button } from './ui';
import { CameraCaptureProps } from './CameraCapture';

/** Web-only implementation (Metro picks this file automatically for the web
 * build, in place of CameraCapture.tsx's expo-camera/getUserMedia version).
 *
 * Deliberately does NOT use getUserMedia + an in-page <video> preview like
 * the native version — that approach is notoriously fragile on iOS Safari:
 * the permission prompt frequently never appears (and the promise just
 * hangs forever) unless requested perfectly synchronously from a tap, with
 * no reliable way to detect or recover from that in JS. A plain
 * `<input type="file" capture>` instead hands the whole camera + permission
 * flow to the OS itself (opens the real native camera app), which every
 * mobile browser already implements correctly — nothing left to hang. */
export function CameraCapture({ onCapture, onCancel }: CameraCaptureProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [opening, setOpening] = useState(false);

  return (
    <View style={[styles.container, styles.centered]}>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          setOpening(false);
          if (file) {
            onCapture(URL.createObjectURL(file), file);
          }
          e.target.value = '';
        }}
      />
      <Text style={{ color: '#fff', marginBottom: 16, textAlign: 'center', paddingHorizontal: 24 }}>
        Chụp ảnh minh chứng bằng camera của máy
      </Text>
      <Button
        title="📷 Chụp ảnh"
        loading={opening}
        onPress={() => {
          setOpening(true);
          inputRef.current?.click();
          // No reliable "cancelled" event from the OS picker on web — clear
          // the loading spinner shortly after so a cancelled dialog doesn't
          // leave the button stuck, without racing the (much slower) real
          // file-selected path above.
          setTimeout(() => setOpening(false), 800);
        }}
      />
      <Button title="Huỷ" variant="outline" onPress={onCancel} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000',
  },
  centered: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
